export * from './group-code.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/group-code/index.ts